import React from 'react';
import Event from '../Event.js';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import ApiRequest from '../ApiRequest';
import ModalForm from '../Form/Form.js';
import moment from 'moment';
import Url from '../Url';

export default class ShortlistModal extends ModalForm {
    constructor(props) {
        super(props);

        this.state = {
            show: false,
            form: {
                shortlistName: ''
            },
            errors: {},
            errorMessage: null,
            successMessage: null,
            shortlistUrl: null,
            loading: false,
            addShortlistLoading: false,
            user: null,
            shortlists: null,
            shortlistRequest: null
        };
    }

    componentDidMount() {
        if (this.props.show) {
            this.setState({ show: true });
        }

        Event.on('shortlistModal.show', (user) => {
            if (window.loggedInUser && [2, 3].indexOf(window.loggedInUser.type) !== -1) {
                this.setState({ show: true, user });
            } else {
                window.location.href = "/login";
            }
        }, this._rootNodeID);

        Event.on('modals.close', () => {
            this.setState({ show: false });
        }, this._rootNodeID);

        if (this.props.shortlists) {
            this.setState({ shortlists: this.props.shortlists });
        } else {
            this.refreshShortlists();
        }
    }

    refreshShortlists() {
        if (window.loggedInUser && [2, 3].indexOf(window.loggedInUser.type) !== -1) {
            this.setState({ loading: true }, () => {
                let request = new ApiRequest();
                request.get('simple-shortlists', {}, (err, res) => {
                    if (res && res.body && res.body.success) {
                        this.setState({ shortlists: res.body.shortlists, loading: false });
                    } else {
                        Bugsnag.notify('Anyone - ShortlistsModal@refreshShortlists:', 'Unexpected error', { err, res });
                    }
                });
            });
        }
    }

    componentWillReceiveProps(props) {
        if (props.shortlists) {
            this.setState({ shortlists: props.shortlists });
        }
    }

    componentWillUnmount() {
        Event.off('shortlistModal.show', this._rootNodeID);
        Event.off('modals.close', this._rootNodeID);
    }

    handleShortlistSelection(e, uid, name) {
        e.preventDefault();
        this.saveShortlist(uid, name);
    }

    saveShortlist(list_uid = null, name = null) {
        if (!this.state.shortlistRequest && !this.state.addShortlistLoading && (list_uid || (this.state.form.shortlistName && this.state.form.shortlistName.length > 1))) {
            let request = new ApiRequest();
            this.setState({
                errors: {},
                addShortlistLoading: true,
                shortlistRequest: request,
                successMessage: null,
                errorMessage: null
            }, () => {
                let params = {
                    user_uid: this.state.user.uid,
                    image_uid: this.state.user.defaultimage
                };
                if (list_uid) {
                    params['list_uid'] = list_uid;
                } else {
                    params['name'] = this.state.form.shortlistName;
                }
                request.post('shortlists', params, (err, res) => {
                    this.setState({ addShortlistLoading: false, shortlistRequest: null }, () => {
                        if (res && res.body && res.body.success) {
                            if (this.props.onUserShortlisted) {
                                this.props.onUserShortlisted(this.state.user);
                            }
                            let shortlistName = name ? name : this.state.form.shortlistName;
                            this.setState({
                                successMessage: `${this.state.user.firstname} has been added to ${shortlistName}.`,
                                form: { shortlistName: '' },
                                shortlistUrl: res.body.shortlistUid ? Url.prefixedUrl(`mandy.com/jobs/shortlist/${res.body.shortlistUid}`) : null
                            });
                            this.refreshShortlists();
                        } else {
                            if (res.status === 400 && res.body.messages) {
                                this.setState({ errors: res.body.messages });
                            } else {
                                this.setState({ errorMessage: (res && res.body && res.body.message) ? res.body.message : 'There was an error adding the user, please try again.' });
                            }
                        }
                    });
                });
            });
        } else {
            let errors = this.state.errors;
            errors.name = ['The shortlist name has to be at least 2 characters long.'];
            this.setState({ errors });
        }
    }

    handleKeyPress(e) {
        if (e.key === 'Enter') {
            this.saveShortlist();
        }
    }

    newShortlistInput() {
        return (
            <div className="row">
                <div className="col-sm-6">
                    <div
                        className={'form-group text-left mb-1 has-float-label ' + this.getErrorClass('name')}>
                        <input id="shortlist_name"
                            value={this.state.form.shortlistName}
                            onChange={(e) => this.handleChange('shortlistName', e.target.value)}
                            placeholder="Create New Shortlist"
                            className="form-control"
                            onKeyPress={(e) => this.handleKeyPress(e)} />
                        <label htmlFor="shortlist_name">Create New Shortlist</label>
                        {this.showError('name')}
                    </div>
                </div>
                <div className="col-sm-3 mb-1">
                    <button className={"btn btn-sm btn-primary" + (this.state.addShortlistLoading ? ' disabled' : '')} onClick={() => this.saveShortlist()} style={{ width: '100%' }}>{this.state.addShortlistLoading ?
                        <i style={{
                            width: '100%',
                            marginLeft: 'auto',
                            marginRight: 'auto',
                            fontSize: '1rem'
                        }} className="fa fa-circle-o-notch fa-spin fa-3x fa-fw"></i> : 'Save New Shortlist'}</button>
                </div>
                <div className="col-sm-3">
                    <button className="btn btn-sm btn-warning" onClick={() => this.toggle()} style={{ width: '100%' }}>Back to Search</button>
                </div>
            </div>
        );
    }

    userInShortlist(shortlist) {
        return shortlist.users.find((user) => (user.uid === this.state.user.uid));
    }

    shortlistsList() {
        if (this.state.user && this.state.shortlists) {
            return this.state.shortlists.map((shortlist, index) => {
                return (!this.userInShortlist(shortlist)) ? (
                    <li key={index} className={"fable-" + (index % 2 ? 'even' : 'odd')}>
                        <div className="set-at-60 float-right text-right">{shortlist.usersWithExtra ? shortlist.usersWithExtra.length : ''}</div>
                        <div className="set-at-200 float-right text-right">{moment(shortlist.created_at).format("Do, MMMM  YYYY HH:mm")}</div>
                        <div>
                            <a href="#" onClick={(e) => this.handleShortlistSelection(e, shortlist.uid, shortlist.name)}>{shortlist.name}</a>
                        </div>
                    </li>
                ) : (
                        <li key={index} className={"fable-" + (index % 2 ? 'even' : 'odd')}>
                            <div className="set-at-60 float-right text-right">{shortlist.usersWithExtra ? shortlist.usersWithExtra.length : ''}</div>
                            <div className="set-at-200 float-right text-right">{moment(shortlist.created_at).format("Do, MMMM  YYYY HH:mm")}</div>
                            <div>{shortlist.name}</div>
                        </li>
                    );
            });
        }
    }

    handleToggle(e = null) {
        if (e) {
            e.preventDefault();
        }
        this.setState({ errorMessage: null, successMessage: null }, () => this.toggle());
    }

    render() {
        return (
            <Modal isOpen={this.state.show} toggle={() => this.handleToggle()} className={'modal-lg'}>
                <ModalHeader toggle={() => this.handleToggle()}>
                    Shortlist {this.state.user ? `${this.state.user.firstname} ${this.state.user.lastname}` : ''}
                </ModalHeader>
                <ModalBody>
                    <div className="row">
                        <div className="col-12">
                            {this.state.errorMessage ? (
                                <div className="alert alert-danger" role="alert">
                                    {this.state.errorMessage}
                                </div>
                            ) : null}
                            {this.state.successMessage ? (
                                <div className="alert alert-success" role="alert">{' '}
                                    {this.state.successMessage} {this.state.shortlistUrl ?
                                        <a href={this.state.shortlistUrl}>View Shortlist.</a> : null}
                                </div>
                            ) : null}
                            <p>Use shortlists to classify and mail groups of suitable professionals.</p>
                            <p className="mb-0"><i>Please note:</i></p>
                            <ul>
                                <li>
                                    <i>Shortlisted candidates <b>will not</b> be automatically notified.</i>
                                </li>
                            </ul>
                            {this.state.shortlists === null ? (
                                <i style={{
                                    width: '100%',
                                    marginLeft: 'auto',
                                    marginRight: 'auto',
                                    fontSize: '1rem'
                                }} className="fa fa-circle-o-notch fa-spin fa-3x fa-fw"></i>
                            ) : (
                                    <div>
                                        {this.state.shortlists.length > 0 ?
                                            <h3>Add candidate to existing shortlist:</h3> : null}
                                        {this.state.shortlists.length > 0 ? (
                                            <ul className="fable">
                                                {this.state.loading ? (
                                                    <i style={{
                                                        width: '100%',
                                                        marginLeft: 'auto',
                                                        marginRight: 'auto',
                                                        fontSize: '1rem'
                                                    }} className="fa fa-circle-o-notch fa-spin fa-3x fa-fw"></i>
                                                ) : this.shortlistsList()}
                                            </ul>
                                        ) : null}
                                        {this.newShortlistInput()}
                                    </div>
                                )}
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                </ModalFooter>
            </Modal>
        );
    }
}